/**
 * Created by mestrad on 2018. 08. 13..
 */

export default TimeLine;
import Style from "./Style";

const $ = jQuery;

//https://momentjs.com/docs/#/displaying/format/
//https://visjs.github.io/vis-timeline/docs/timeline/#Configuration_Options
const timeLineFormat = {
    minorLabels: {
        millisecond: 'SSS',
        second: 'ss',
        minute: 'HH:mm',
        hour: 'HH:mm',
        weekday: 'dddd Do.',
        day: 'dddd Do.',
        week: 'w',
        month: 'MMMM',
        year: 'YYYY'
    },
    majorLabels: {
        millisecond: 'YYYY. MMMM Do. HH:mm:ss SSS',
        second: 'YYYY. MMMM Do. (dddd) HH:mm:ss',
        minute: 'YYYY. MMMM Do. (dddd) HH:mm',
        hour: 'YYYY. MMMM Do. (dddd) HH:mm',
        weekday: 'YYYY. MMMM Do. (dddd)',
        day: 'YYYY. MMMM Do. (dddd)',
        week: 'YYYY. MMMM / w',
        month: 'YYYY. MMMM',
        year: 'YYYY'
    }
}


function TimeLine(config) {
    var timeLine;
    var timeLineDomEl;
    var items = new vis.DataSet({
        type: {start: 'ISODate'}
    });
    var dataSheetCustomTimeId = "customTimeActualDate";
    var filterCustomTimeDateFrom = "customTimeDateFrom";
    var filterCustomTimeDateTo = "customTimeDateTo";
    var filterDateFrom;
    var filterDateTo;
    var options;
    var searchStartDate;
    var searchEndDate;
    var range;
    init();

    function init() {
        if (!config) return;

        timeLineDomEl = document.getElementById(config.selectors.elementId);

        if (!timeLineDomEl) return;

        document.getElementById(config.selectors.zoomInId).onclick = function () {
            timeLine.zoomIn(0.2);
        };
        document.getElementById(config.selectors.zoomOutId).onclick = function () {
            timeLine.zoomOut(0.2);
        };
        document.getElementById(config.selectors.moveLeftId).onclick = function () {
            move(0.2);
        };
        document.getElementById(config.selectors.moveRightId).onclick = function () {
            move(-0.2);
        };
    }

    function refresh(feed, actualDate) {
        if (!timeLineDomEl) return;

        if (timeLine && timeLine.getVisibleItems() != null) {
            items = new vis.DataSet({
                type: {start: 'ISODate'}
            });
        }


        if (config.type == "datasheet") {
            refreshTimeLineDataSheet(feed, actualDate);
        } else if (config.type == "search") {
            refreshTimeLineSearch(feed);
        }
    }

    function refreshTimeLineSearch(feed) {
        options = {
            clickToUse: false,
            autoResize: true,
            stack: true,
            height: 128,
            locales: {
                hu: {
                    current: 'aktuális',
                    time: 'idő',
                    week: {
                        dow: 1 // Monday is the first day of the week.
                    },
                },

                en: {
                    current: "current",
                    time: "time"
                }
            },
            locale: config.locale,
            start: '1900-01-01',
            end: Date.now(),
            margin: {
                item: {
                    horizontal: 0,
                    vertical: 0
                }
            },
            format: timeLineFormat

        };

        if (feed) {
            range = timeLine.getWindow();
            feed.forEach(function (item) {
                items.add({
                    id: item.id,
                    start: item.from,
                    content: item.content

                });
                if (searchStartDate == undefined && searchEndDate == undefined) {
                    searchStartDate = item.from;
                    searchEndDate = item.from;
                } else {
                    if (searchStartDate > item.from) {
                        searchStartDate = item.from;
                    }
                    if (searchEndDate < item.from) {
                        searchEndDate = item.from;
                    }
                }
            });
        } else {
            options.start = '1800-01-01'
        }
        if (timeLine) {
            timeLine.destroy();
        }
        timeLine = new vis.Timeline(timeLineDomEl, items, options);
        initEventsSearch();
        /*
        if (filterDateFrom != undefined && filterDateTo != undefined) addFilterCustomTime(filterDateFrom, filterDateTo);
         */
        if (feed) {
            moveTimeLineTo(new Date(searchEndDate), new Date(searchStartDate));
            searchStartDate = undefined;
            searchEndDate = undefined;
        }
    }

    function refreshTimeLineDataSheet(feed, actualDate) {
        if (!Array.isArray(feed) || feed.length == 0) {
            $(config.domElements.wrapperSelector).addClass("nnpHidden");
            return;
        }
        options = {
            editable: false,
            clickToUse: false,
            autoResize: true,
            stack: true,
            height: 142,
            locales: {
                hu: {
                    current: 'aktuális',
                    time: 'idő',
                    week: {
                        dow: 1 // Monday is the first day of the week.
                    },
                },
                en: {
                    current: "current",
                    time: "time"
                }
            },
            locale: config.locale,
            format: timeLineFormat,
            end: Date.now()
        };


        if (!actualDate instanceof Date) {
            actualDate = Date.now();
        }


        if (feed.length) {

            let hasNotMillennium = false;

            feed.forEach(function (item) {
                if (moment(item.from).isValid()) {


                    if (typeof item.from === 'string') {
                        item.from = moment(item.from);
                    }

                    //adatszűrés a kezdő dátum megállapításához
                    if (item.from.format('YYYY-MM-DD') !== '1000-01-01') {
                        hasNotMillennium = true;
                    }
                    if (hasNotMillennium) {
                        items.add({
                            id: item.id,
                            content: item.content,
                            start: item.from,
                            title: item.title,
                            className: item.className,
                        });
                    }
                }
            });

            if (hasNotMillennium === false) {
                options.start = '1800-01-01'
            }
        } else {
            options.start = '1800-01-01'
        }

        if (timeLine) timeLine.destroy();
        timeLine = new vis.Timeline(timeLineDomEl, items, options);
        timeLine.addCustomTime(actualDate, dataSheetCustomTimeId);

        initEventsDataSheet(feed);
    }

    function initEventsDataSheet(feed) {
        timeLine.on("doubleClick", function (event) {
            var $actualDate = $(config.domElements.actualDatePicker);
            if (event.item == null) {
                setCustomTimeDataSheet(event.time);
                $actualDate.datepicker("setDate", event.time);
            } else {
                var startDate;
                feed.forEach(function (item) {
                    if (item.id == timeLine.getSelection()) {
                        startDate = moment(item.from).format("YYYY-MM-DD");
                        return;
                    }
                });
                setCustomTimeDataSheet(startDate);
                $actualDate.datepicker("setDate", new Date(startDate));
            }
            $actualDate.trigger("change");
        });
        timeLine.on("timechanged", function (event) {
            var $actualDate = $(config.domElements.actualDatePicker);
            $actualDate.datepicker("setDate", event.time);
            $actualDate.trigger("change");
        });
    }

    function initEventsSearch() {
        timeLine.on("timechanged", function (event) {
            if (event.id == filterCustomTimeDateFrom) {
                if (timeLine.getCustomTime(filterCustomTimeDateTo) < event.time) {
                    setDateIntervallInput(timeLine.getCustomTime(filterCustomTimeDateTo), event.time);
                    swapFilterCustomTimeItems(event.time, timeLine.getCustomTime(filterCustomTimeDateTo));
                } else {
                    $(config.domElements.searchDateFrom).datepicker("setDate", event.time);
                }
            } else if (event.id == filterCustomTimeDateTo) {
                if (timeLine.getCustomTime(filterCustomTimeDateFrom) > event.time) {
                    setDateIntervallInput(event.time, timeLine.getCustomTime(filterCustomTimeDateFrom));
                    swapFilterCustomTimeItems(timeLine.getCustomTime(filterCustomTimeDateFrom), event.time);
                } else {
                    $(config.domElements.searchDateTo).datepicker("setDate", event.time);
                }
            }
            moveTimeLineTo(timeLine.getCustomTime(filterCustomTimeDateFrom), timeLine.getCustomTime(filterCustomTimeDateTo));
        });
        timeLine.on("doubleClick", function () {
            if (timeLine.getSelection().length != 0) {
                var id = timeLine.getSelection()[0];
                var actualDate = moment(Date.now()).format("YYYY-MM-DD");
                window.history.pushState({}, "", "?id=" + id + "&date=" + actualDate);
                Style.hide($(config.domElements.searchWidget));
                Style.hide($(config.domElements.resultListWidget));
                $(config.domElements.eventHandlerNode).trigger("showDataSheet", [{
                    id: id,
                    actualDate: actualDate,
                    parentSystemType: 0
                }]);
            }
        });
        timeLine.on("itemover", function (event) {
            $("#resultItem" + event.item).addClass("hoverResultList");
        });
        timeLine.on("itemout", function (event) {
            $("#resultItem" + event.item).removeClass("hoverResultList");
        });
    }

    function setDateIntervallInput(dateFrom, dateTo) {
        $(config.domElements.searchDateFrom).datepicker("setDate", dateFrom);
        $(config.domElements.searchDateTo).datepicker("setDate", dateTo);
    }

    function swapFilterCustomTimeItems(dateFrom, dateTo) {
        timeLine.setCustomTime(dateTo, filterCustomTimeDateFrom);
        timeLine.setCustomTime(dateFrom, filterCustomTimeDateTo);
    }

    function addFilterCustomTime(dateFrom, dateTo) {
        var range = timeLine.getWindow();
        timeLine.addCustomTime(dateFrom, filterCustomTimeDateFrom);
        timeLine.addCustomTime(dateTo, filterCustomTimeDateTo);
        setDateIntervallInput(dateFrom, dateTo);
        moveTimeLineTo(new Date(dateFrom), new Date(dateTo));
        if (range.start.getFullYear() >= new Date(dateFrom).getFullYear() || range.end.getFullYear() <= new Date(dateTo).getFullYear()) {
            zoomOut(0.2);
        }
        filterDateFrom = dateFrom;
        filterDateTo = dateTo;
    }

    function removeFilterCustomTime() {
        if (filterDateFrom != undefined) timeLine.removeCustomTime(filterCustomTimeDateFrom);
        if (filterDateTo != undefined) timeLine.removeCustomTime(filterCustomTimeDateTo);
        filterDateFrom = undefined;
        filterDateTo = undefined;
    }

    function setFilterCustomTime(dateFrom, dateTo) {
        if (dateFrom !== null && dateTo !== null) {
            timeLine.setCustomTime(dateFrom, filterCustomTimeDateFrom);
            timeLine.setCustomTime(dateTo, filterCustomTimeDateTo);
            moveTimeLineTo(dateFrom, dateTo);
        }
    }

    function revertFilterDateIntervall() {
        setDateIntervallInput(timeLine.getCustomTime(filterCustomTimeDateFrom), timeLine.getCustomTime(filterCustomTimeDateTo));
    }

    function setCustomTimeDataSheet(date) {
        if (timeLine) {
            timeLine.setCustomTime(date, dataSheetCustomTimeId);
            timeLine.moveTo(date);
        }
    }

    function moveTimeLineTo(dateFrom, dateTo) {
        timeLine.moveTo(new Date((dateTo - dateFrom * -1) / 2));
        timeLine.fit();
    }

    function move(percentage) {
        var range = timeLine.getWindow();
        var interval = range.end - range.start;
        timeLine.setWindow({
            start: range.start.valueOf() - interval * percentage,
            end: range.end.valueOf() - interval * percentage
        });
    }

    function zoomOut() {
        timeLine.zoomOut(0.2);
    }

    function destroy() {
        $(config.domElements.wrapperSelector).addClass("nnpHidden");
        if (timeLine) timeLine.destroy();
    }

    function setFilterDates(startDate, endDate) {
        filterDateFrom = startDate;
        filterDateTo = endDate;
    }

    return {
        refresh: refresh,
        destroy: destroy,
        setCustomTimeDataSheet: setCustomTimeDataSheet,
        revertFilterDateIntervall: revertFilterDateIntervall,
        addFilterCustomTime: addFilterCustomTime,
        setFilterCustomTime: setFilterCustomTime,
        removeFilterCustomTime: removeFilterCustomTime,
        setFilterDates: setFilterDates
    };
}